<div class="container">
  <div class="header">
    <pdq-heading element="h3">Delete recipe?</pdq-heading>
    <pdq-button (onClick)="onClose()" iconColor="var(--on-surface-light)" variant="ghost" icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">You’re about to delete an integration recipe.</div>
  </div>
  <footer>
    <pdq-button label="Cancel" (onClick)="onClose()"></pdq-button>
    <pdq-button (onClick)="onDelete()" variant="danger" label="Delete"></pdq-button>
  </footer>
</div>
